// src/routes/Routes.js
import React from "react";
import { createBrowserRouter } from "react-router-dom";

import Home from "../pages/Home";
import Profile from "../pages/Profile";
import EditProfile from "../pages/EditProfile";
import DigitalGiftCentre from "../pages/DigitalGiftCentre";
import ViewMemories from "../pages/ViewMemories";
import ProtectedRoute from "./ProtectedRoute";
import ResetPassword from "../pages/ResetPassword";
import Medallion from "../pages/Medallion";
import PetMedallion from "../pages/PetMedallion";
import PaymentVerify from "../pages/PaymentVerify";
import PaymentCancel from "../pages/PaymentCancel";
import HowItWorks from "../pages/HowItWorks";
import QRScanner from "../pages/QRScanner";
import ProfileView from "../pages/ProfileView";
import ARGiftScene from "../pages/ARGiftScene";

/**
 * Export the router used by RouterProvider in App.js.
 * Mark routes that should be protected by wrapping their element with <ProtectedRoute>.
 *
 * Adjust which routes are protected below (currently profile, medallian, digital-gift-centre, view-memories).
 */
const router = createBrowserRouter([
  { path: "/", element: <Home /> },
  { path: "/profile/:id", element: <><Profile /></> },
  { path: "/edit-profile/:id", element: <><EditProfile /></> },
  { path: "/medallion", element: <><Medallion /></> },
  { path: "/pet-medallion", element: <><PetMedallion /></> },
  { path: "/digital-gift-centre", element: <><DigitalGiftCentre /></> },
  { path: "/digital-gift-centre/:id", element: <><DigitalGiftCentre /></> },
  { path: "/how-it-works", element: <><HowItWorks /></> },
  { path: "/view-memories", element: <><ViewMemories /></> },
  { path: "/reset-password/:token", element: <><ResetPassword /></> },
  { path: "/payment/verify/:session_id", element: <><PaymentVerify /></> },
  { path: "/payment/cancel", element: <><PaymentCancel /></> },
  { path: "/purchase-gift/:gift_id", element: <><QRScanner /></> },
  { path: "/profile-view", element: <><ProfileView /></> },
  { path: "/ar/:med_id", element: <><ARGiftScene /></> },

]);

export default router;
